/// <reference path="../../types/signalr.d.ts" />

namespace SP {
    export class DropDown {
        items: DropDownItem[] = [];
        item_dictionary: { [value: string]: DropDownItem } = {};
        container: HTMLElement;
        selectedItem: DropDownItem = null;
        selected_container: HTMLElement = document.createElement("div");
        item_container: HTMLElement = document.createElement("ul");
        icon_container: HTMLElement = document.createElement("div");
        _changeEvents: ((val: string) => any)[] = [];
        _open = false;

        constructor(container: HTMLElement, icon: string) {
            this.container = container;
            this.container.classList.add("sp_drop_down");

            if (icon) {
                this.icon_container.classList.add("icon");
                this.container.appendChild(this.icon_container);
                this.icon_container.innerHTML = `<img src='${icon}' />`
            }
            else {
                this.selected_container.style.left = "0px";
            }

            this.selected_container.classList.add("current");
            this.container.appendChild(this.selected_container);
            this.item_container.classList.add("sp_resultList");
            this.container.appendChild(this.item_container);

            this.selected_container.addEventListener("click", () => {
                if (this._open)
                    this.hide();
                else
                    this.open();
            });

            this.hide();
        }

        onChange(fn: (val: string) => any) {
            this._changeEvents.push(fn);

        }

        add(value: string, text: string, enabled: boolean) {
            let item = new DropDownItem(this, value, text, enabled);
            this.item_container.appendChild(item.element);

            item.element.addEventListener("click", () => {
                this.value = item.value;

                for (let i = 0; i < this._changeEvents.length; i++) {
                    this._changeEvents[i](item.value);
                }
            });

            this.item_dictionary[item.value] = item;
            this.items.push(item);

            if (this.selectedItem == null) this.value = item.value;
        }

        clear() {
            this.item_container.innerHTML = "";
            this.item_dictionary = {};
            this.items = [];
            this.selectedItem = null;
            this.value = null;
        }

        get value() {
            return this.selectedItem?.value ?? null;
        }

        set value(val: string) {
            if (this.selectedItem != null) {
                this.selectedItem.element.classList.remove("selected");
            }

            let item = this.item_dictionary[val];
            if (item != null) {
                this.selectedItem = item;
                this.selectedItem.element.classList.add("selected");
                this.selected_container.innerHTML = item.text;



                if (item.enabled) this.selected_container.classList.remove("disabled");
                else this.selected_container.classList.add("disabled");

            }
            this.hide();
        }

        outside_click: any = null;

        async open() {
            this.item_container.style.display = "block";
            this._open = true;
            if (this.selectedItem != null) {
                await SP.sleep(0);
                this.selectedItem.element.scrollIntoView();
            }

            if (this.outside_click == null) {
                this.outside_click = (evt: MouseEvent) => {
                    const flyoutElement = this.container;
                    let targetElement = evt.target as HTMLElement; // clicked element

                    do {
                        if (targetElement == flyoutElement) {
                            return;
                        }
                        // Go up the DOM
                        targetElement = targetElement.parentNode as HTMLElement;
                    } while (targetElement);

                    // This is a click outside.
                    this.hide();
                }
                document.addEventListener("click", this.outside_click);
            }




        }

        hide() {
            if (this.outside_click != null) {
                document.removeEventListener("click", this.outside_click);
                this.outside_click = null;

            }

            this.item_container.style.display = "none";
            this._open = false;

        }
    }

    export class DropDownItem {
        _value: string;
        _text: string;
        _enabled: boolean = false;
        element: HTMLElement;
        _dropdown: DropDown;

        constructor(dd: DropDown, value: string, text: string, enabled: boolean) {
            this._dropdown = dd;
            this.element = document.createElement("li");
            this.element.classList.add("item");
            this.value = value;
            this.text = text;
            this.enabled = enabled;

        }

        set text(val: string) {
            this._text = val;
            this.element.innerHTML = this._text;
        }

        get text() {
            return this._text;
        }

        set value(val: string) {
            this._value = val;
        }

        get value() {
            return this._value;
        }

        set enabled(val: boolean) {
            if (val) this.element.classList.remove("disabled");
            else this.element.classList.add("disabled");

            if (this._dropdown.selectedItem == this) {
                if (val) this._dropdown.selected_container.classList.remove("disabled");
                else this._dropdown.selected_container.classList.add("disabled");
            }

            this._enabled = val;
        }

        get enabled() {
            return this._enabled;
        }
    }

}